import * as React from "react";

const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    fill="none"
    viewBox="0 0 21 21"
  >
    <path
      fill="#FAAD14"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 0C16.298 0 21 4.702 21 10.5S16.298 21 10.5 21 0 16.298 0 10.5 4.702 0 10.5 0m0 13.5a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25m.563-8.25H9.937a.19.19 0 0 0-.187.188v6.375c0 .102.084.187.188.187h1.124a.19.19 0 0 0 .188-.187V5.437a.19.19 0 0 0-.187-.187z"
    ></path>
  </svg>
);

export default WarningIcon;
